import { useState } from "react";
import { useInView } from "react-intersection-observer";
import { cn } from "@/lib/utils";
import type { AsyncImageProps } from "./types";

const AsyncImage = ({
  src,
  alt = "",
  className = "",
  skeletonClassName,
  rootMargin = "0px 0px",
  onError,
  loadImmediately = false,
  wrapperClassName,
  ...props
}: AsyncImageProps) => {
  const [loaded, setLoaded] = useState(false);
  const { ref, inView } = useInView({ triggerOnce: true, rootMargin });
  const shouldLoad = loadImmediately || inView;

  return (
    <div ref={ref} className={wrapperClassName}>
      {!shouldLoad && <div className={cn(className, "animate-pulse bg-white/10", skeletonClassName)}></div>}

      {shouldLoad && (
        <>
          {!loaded && (
            <>
              <img
                src={src}
                alt=""
                aria-hidden
                onLoad={() => setLoaded(true)}
                onError={onError}
                className="hidden"
                loading="eager"
                decoding="async"
              />
              <div className={cn(className, "animate-pulse bg-white/10", skeletonClassName)}></div>
            </>
          )}
          {loaded && (
            <img
              src={src}
              alt={alt}
              onError={onError}
              className={className}
              loading="lazy"
              decoding="async"
              fetchPriority="low"
              {...props}
            />
          )}
        </>
      )}
    </div>
  );
};

export default AsyncImage;
